import api from './api';

export const getApplications   = (status = 'pending') => api.get('/api/approvals', { params: { status } });
export const getApprovalStats  = ()                    => api.get('/api/approvals/stats');
export const getPendingCount   = ()                    => api.get('/api/approvals/count');
export const approveUser       = (id)                  => api.put(`/api/approvals/${id}/approve`);
export const rejectUser        = (id, reason)          => api.put(`/api/approvals/${id}/reject`, { reason });
export const deleteApplication = (id)                  => api.delete(`/api/approvals/${id}`);

// Keep backward-compat alias used by Sidebar badge
export const getPendingUsers = () => getApplications('pending');
